export default {"src":"/_next/static/media/helium.7ea8623e.svg","height":60,"width":112,"blurWidth":0,"blurHeight":0};